export async function getNotificationsApi() {
  let response = await fetch(
    process.env.REACT_APP_API_ROOT + "complete_notifications"
  );

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}

export async function delNotificationApi(notificationID) {
  let response = await fetch(
    process.env.REACT_APP_API_ROOT + "complete_notifications/" + notificationID,
    {
      method: "DELETE"
    }
  );

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}
